import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  modalBanner: {
    padding: 12,
  },
}));

export default useStyles;
